<template>
  <div class="public-kye-area-select"
       ref="addressSelect">
      <el-popover
        placement="bottom-start"
        trigger="click"
        :disabled="disabled"
        v-bind="$attrs"
        :popper-class="`public-kye-address-popper public-kye-address-custom-${popperClass}`"
        v-model="menuVisible"
        >
        <AddressMenu
          ref="address"
          :level="level"
          :hotList="hotList"
          :areaData="currentData"
          :showMenu="menuVisible"
          :isSelectAll="isSelectAll"
          :maxlength="maxlength"
          :readOnly="readOnly"
          :showCountry="showCountry"
          :showCheckBoxMaps="showCheckBoxMaps"
          :beforeSearch="beforeSearch"
          :filterSearchData="filterSearchData"
          :beforeAdd="beforeAdd"
          :beforeSumbit="beforeSumbit"
          @showMenu="changeMenu()"
          @change="areaChange"/>
        <slot v-if="$slots.default" slot="reference"></slot>
        <el-input v-else slot="reference" v-model="addressInput"
            :disabled="disabled"
            readonly
            :placeholder="currentData.length ? '' : placeholder"
            @mouseenter.native="hover = true"
            @mouseleave.native="hover = false"
            >
          <i slot="suffix"
            v-if="hover && hasData && !disabled"
            @click.stop="clearAllData"
            class="el-input__icon el-icon-circle-close el-input__clear"
          >
          </i>
          <div slot="prefix" class="perfix_slot" :class="[hover && hasData && !disabled ? 'perfix_slot-sub-clear-width' : 'perfix_slot-normal-width']" v-if="currentData.length">
            <span class="flex">
              <el-tag
                size="mini"
                type="info"
                disable-transitions
                class="perfix_slot-tag-content-width">
                <span class="el-select__tags-text">{{ currentData[0].simpleName || currentData[0].districtName }}</span>
              </el-tag>
              <el-tag
                v-if="currentData.length > 1"
                size="mini"
                type="info"
                disable-transitions>
                <span class="el-select__tags-text">+ {{ currentData.length - 1 }}</span>
              </el-tag>
            </span>
          </div>
        </el-input>
      </el-popover>
  </div>
</template>
<script>
import { HOT_CITY_LIST } from './common'
import cloneDeep from 'lodash/cloneDeep'
import AddressMenu from './area-picker'
export default {
  name: 'kye-area-select',
  components: {
    AddressMenu
  },
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    popperClass: {
      type: String,
      default: '',
    },
    hotList: {
      type: Array,
      default: () => (cloneDeep(HOT_CITY_LIST))
    },
    level: {
      type: Number,
      default: 5,
      validator: (value) => {
        return [2, 3, 4, 5].indexOf(value) !== -1
      }
    },
    placeholder: {
      type: String,
      default: '请选择区域'
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    beforeSearch: {
      type: Function
    },
    filterSearchData: {
      type: Function
    },
    beforeChange: {
      type: Function
    },
    beforeAdd: {
      type: Function
    },
    beforeSumbit: {
      type: Function
    },
    isSelectAll: {
      type: Boolean,
      default: true
    },
    showCheckBoxMaps: {
      type: Object,
      default: () => {
        return {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true
        }
      }
    },
    showCountry: {
      type: Boolean,
      default: true
    },
    // 批量粘贴链接符
    batchPateSeparator: {
      type: String,
      default: '/'
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        val.forEach(item => {
          item.isHistory = true
        })
        this.hasData = !!val.length
        this.currentData = val
      }
    }
  },
  data() {
    return {
      menuVisible: false,
      addressInput: '',
      showPopupModel: '',
      currentData: null,
      hover: false,
      hasData: false
    }
  },
  methods: {
    changeMenu(show) {
      this.menuVisible = false
    },
    clearAllData () {
      this.hasData = false
      this.menuVisible = false
      this.$emit('input', [])
      this.$emit('change', [])
    },
    areaChange(data) {
      this.currentData = data
      let changeData
      if (this.beforeChange && typeof this.beforeChange === 'function') {
        changeData = this.beforeChange(data)
      } else {
        changeData = data.map(item => {
          return {
            districtName: item.districtName,
            simpleName: item.simpleName || item.districtName,
            districtID: item.districtID,
            districtLevel: item.districtLevel,
            zoneCode: item.zoneCode,
            districtAllId: item.districtAllId
          }
        })
      }
      this.$emit('input', changeData)
      this.$emit('change', changeData)
    },
  }
}
</script>
<style lang="scss">
.public-kye-address-popper {
  padding: 0;
}
.public-kye-area-select {
  &::after {
    content: " ";
    height: 0;
    visibility: hidden;
    display: block;
    clear: both;
  }
  .suffix {
    // margin-top: 10px;
    // width: 0;
    // height: 0;
    width: 12px;
    line-height: 28px;
    color: #b7b7c7;
    font-size: 12px;
    font-family: "layout" !important;
    cursor: pointer;
    // border-color: #9595ca transparent transparent;
    // border-width: 6px 6px 0;
    // border-radius: 8px 8px;
    border-style: solid;
    vertical-align: middle;
    transition: transform 0.3s;
    transform: rotateZ(180deg);

    &::before {
      content: "\EEEA";
    }

    &.active {
      transform: rotateZ(0);
    }
  }
  .el-input__prefix {
    width: 100%;
  }
  .perfix_slot {
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
  }
  .perfix_slot-normal-width {
    width: calc(100% - 6px);
  }
  .perfix_slot-sub-clear-width {
    width: calc(100% - 30px);
  }
  .perfix_slot-tag-content-width {
    // width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .flex {
    display: flex;
    align-items: center;
      .el-tag {
        margin-right: 4px;
      }
  }
}
</style>




// WEBPACK FOOTER //
// src/public/components/kye-area-select/index.vue